import { useContext } from 'react';

import { PromoDrawerModelContext } from '../contexts/PromoDrawerModelProvider';

export const usePromoDrawerModel = () => useContext(PromoDrawerModelContext);
